import {actions as A} from '../../constants/actions';

export const setShumaStatusTypeId = shumaStatusTypeID => dispatch => {
  dispatch({
    type: A.SET_SHUMA_STATUS_TYPE_ID,
    payload: {shumaStatusTypeID}
  });
};
